import React from "react";
import { useOrg } from "src/components/providers/org-provider";
import Icon from "../icon";
import logo from "../../assets/icons/logo";
import nameLogo from "../../assets/icons/name-logo";
import Flex from "../flex";

const Logo = () => {
    const [hover, setHover] = React.useState(false);
    const { org } = useOrg();

    return (
        <Flex onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            {org && org.logoUrl ? (
                <img
                    src={org.logoUrl}
                    alt=""
                    style={{
                        height: "30px",
                    }}
                />
            ) : (
                <Icon svg={logo} width="17" height="17" logo fill="palette.primary.main" />
            )}
            <Icon
                svg={nameLogo}
                width="17"
                height="17"
                logo
                fill={hover ? "palette.primary.main" : undefined}
            />
        </Flex>
    );
};

export default Logo;
